import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Import and register all controllers
import RemovableController from "./removable_controller"
application.register("removable", RemovableController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PropertyMapController from "./property_map_controller"
application.register("property-map", PropertyMapController)

import ElevationMapController from "./elevation_map_controller"
application.register("elevation-map", ElevationMapController)

import PropertyBoundaryGardenController from "./property_boundary_garden_controller"
application.register("property-boundary-garden", PropertyBoundaryGardenController)

import ViewSelectorController from "./view_selector_controller"
application.register("view-selector", ViewSelectorController)

import TopDownViewController from "./top_down_view_controller"
application.register("top-down-view", TopDownViewController)

import GardenPlantPanelController from "./garden_plant_panel_controller"
application.register("garden-plant-panel", GardenPlantPanelController)

import PaddleCheckoutController from "./paddle_checkout_controller"
application.register("paddle-checkout", PaddleCheckoutController)

import PlantSearchController from "./plant_search_controller"
application.register("plant-search", PlantSearchController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import ProfileController from "./profile_controller"
application.register("profile", ProfileController)

import GuidedFlowGateController from "./guided_flow_gate_controller"
application.register("guided-flow-gate", GuidedFlowGateController)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }